export const LIST_TYPE_MENU_OPTION_ID_PREFIX = 'listType--';
